import { render, staticRenderFns } from "./management-information.vue?vue&type=template&id=5df2b01f"
import script from "./management-information.vue?vue&type=script&lang=js"
export * from "./management-information.vue?vue&type=script&lang=js"
import style0 from "./management-information.vue?vue&type=style&index=0&id=5df2b01f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports